<h1 mat-dialog-title>
  Changing price of
  <strong>{{ productName }}</strong>
  for
  <strong>{{ customerName }}</strong>
</h1>
<form (ngSubmit)="submit()" [formGroup]="formGroup">
  <div mat-dialog-content>
    <p>
      The subscription's next renewal price is currently set to
      <strong>{{ currentUnitPrice | currency }}</strong>
      .
    </p>
    <mat-form-field appearance="outline">
      <mat-label>Enter Amount</mat-label>
      <mat-icon matPrefix>attach_money</mat-icon>
      <input matInput formControlName="currentUnitPrice" type="number" />
      <mat-error *ngIf="formGroup.get('currentUnitPrice').hasError('min')">
        Amount must be greater than zero.
      </mat-error>
    </mat-form-field>
  </div>
  <mat-dialog-actions class="dialog-actions" align="end">
    <button
      mat-button
      type="button"
      mat-dialog-close
      class="left-action-button"
    >
      Cancel
    </button>
    <button
      type="submit"
      mat-raised-button
      color="primary"
      [disabled]="formGroup.invalid || (loading$$ | async) === true"
    >
      <div class="loading-button">
        <ng-container
          *ngIf="(loading$$ | async) !== true; else loadingSpinner"
          class="loading-button"
        >
          <mat-icon icon>done</mat-icon>
        </ng-container>
        <span>Submit</span>
      </div>
    </button>
  </mat-dialog-actions>
</form>

<ng-template #loadingSpinner>
  <mat-progress-spinner
    [diameter]="24"
    mode="indeterminate"
  ></mat-progress-spinner>
</ng-template>
